import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    private searchSubject = new Subject<string>();
    private currentSearch = '';

    search(): Observable<string> {
        return this.searchSubject;
    }

    setSearch(search: string) {
        if (
            this.currentSearch != search &&
            (search?.length >= 3 || search?.length == 0)
        )
            this.searchSubject.next(search);
        this.currentSearch = search;
    }
}
